<template>
	<div class="componentSty">
		<m-title :titlelist="listitem"></m-title>
		<div class="componentSty_content">
			<div class="componentSty_content_title">
				<span class="fonints">计划单号</span>
				<el-input placeholder="请输入关键词" v-model="conditions.pno" clearable>
				</el-input>
				<span class="fonints">车牌号码</span>
				<el-input placeholder="请输入关键词" v-model="conditions.plate" clearable>
				</el-input>
				<span class="fonints">司机姓名</span>
				<el-input placeholder="请输入关键词" v-model="conditions.driverName" clearable>
				</el-input>
				<span class="fonints">七日途经城市</span>
				<el-input placeholder="请输入关键词" v-model="conditions.tuJing" clearable>
				</el-input>
			</div>
			<div class="componentSty_content_title">
			   <span class="fonints">作业状态</span>
				<div class="cheboxSty" style="margin-left:20px">
					<el-checkbox-group v-model="statusarr">
						<el-checkbox v-for="item in MyCheckboxList" :label="item.status" :key="item.name">
							{{ item.name }}</el-checkbox>
					</el-checkbox-group>
				</div>
				<span class="fonints">防疫时间</span>
				<el-date-picker v-model="datamsg" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
					range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
				</el-date-picker>
			</div>
			<div class="componentSty_content_title">
				

				<button class="buttons" @click="querylist">查询</button>
				<button class="buttons" @click="cleartiaojian" style="background: #ff5926">
					清空
				</button>
				<el-checkbox style="margin-left: 10px;" @change="handleCheckAllChange">含随车人员</el-checkbox>
				<button class="buttons" style="background: #0057be;margin-right: 20px;" @click="printList">
					导出Excel
				</button>
				
				<el-radio-group v-model="fangyikaiguan">
				   <el-radio label="开">开</el-radio>
				   <el-radio label="关">关</el-radio>
				 </el-radio-group>
				<button class="buttons" style="background: rgb(239, 107, 96)" @click="guankaifangyi">
					配置防疫开关
				</button>
				
			</div>
			<div class="componentSty_content_table" style="top: 150px;border:none">
				<el-table :data="arrlist.list" border style="width: 100%; " height="80%">
					<el-table-column show-overflow-tooltip label="序号" type="index" width="50px"></el-table-column>
					<el-table-column show-overflow-tooltip label="详情">
						<template v-slot="res">
							<span @click="iteminfofun(res.row)" class="iconfont icon-chakan"></span>
						</template>
					</el-table-column>
					<el-table-column width="150px" label="作业状态">
						<template v-slot="res">
							<span>{{ numConvertName(res.row.status) }}</span>
						</template>
					</el-table-column>
					<el-table-column width="120px" prop="pno" label="计划单号"></el-table-column>
					<el-table-column width="100px" prop="plate" label="车牌号"></el-table-column>
					<el-table-column width="100px" prop="driver_name" label="司机姓名"></el-table-column>
					<el-table-column width="150px" prop="driver_creticard" label="身份证号"></el-table-column>
					<el-table-column width="110px" prop="telephone" label="手机号"></el-table-column>
					<el-table-column width="150px" label="派车时间">
						<template v-slot="res">
							<span>{{ mydateFormat(res.row.pctime, "时分秒") }}</span>
						</template>
					</el-table-column>
					<el-table-column width="150px" label="防疫上传时间">
						<template v-slot="res">
							<span>{{ mydateFormat(res.row.fytime, "时分秒") }}</span>
						</template>
					</el-table-column>
					<el-table-column width="120px" label="七日内是否离津">
						<template v-slot="res">
							<span style="color: #ef6b60" class="el_spanfontstyle"
								v-if="res.row.leave_tianjin == 0">是</span>
							<span style="color: #448aff" class="el_spanfontstyle"
								v-if="res.row.leave_tianjin == 1">否</span>
						</template>
					</el-table-column>
					<el-table-column width="130px" prop="tu_jing" label="七日途经地"></el-table-column>
					<el-table-column width="130px" prop="tu_jing_old" label="七日途经地图片识别值"></el-table-column>
					<el-table-column width="150px" label="体温是否正常">
						<template v-slot="res">
							<span style="color: #ef6b60" class="el_spanfontstyle"
								v-if="res.row.body_temperature == 0">正常</span>
							<span style="color: #448aff" class="el_spanfontstyle"
								v-if="res.row.body_temperature == 1">否</span>
						</template>
					</el-table-column>
					<el-table-column width="150px" label="是否落地核酸检测">
						<template v-slot="res">
							<span style="color: #ef6b60" class="el_spanfontstyle"
								v-if="res.row.arriving_check == 0">是</span>
							<span style="color: #448aff" class="el_spanfontstyle"
								v-if="res.row.arriving_check == 1">否</span>
						</template>
					</el-table-column>
					<el-table-column width="120px" prop="arriving_check_place" label="核酸检测地点"></el-table-column>
					<el-table-column width="150px" label="核酸检测时间">
						<template v-slot="res">
							<span>{{ mydateFormat(res.row.arriving_check_time, "时分秒") }}</span>
						</template>
					</el-table-column>
					<el-table-column width="150px" label="是否有48小时核酸阴性证明">
						<template v-slot="res">
							<span style="color: #ef6b60" class="el_spanfontstyle"
								v-if="res.row.report48_hours == 0">是</span>
							<span style="color: #448aff" class="el_spanfontstyle"
								v-if="res.row.report48_hours == 1">否</span>
						</template>
					</el-table-column>
					<el-table-column width="120px" prop="appliance_crews" label="随车人员人数"></el-table-column>
				</el-table>
				<div class="paginations" v-show="arrlist.list && arrlist.list.length">
					<el-pagination :page-size="conditions.limit" layout="total,prev, pager,next, jumper"
						:total="arrlist.totalCount" :current-page="conditions.page"
						@current-change="handleCurrentChange">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import mTitle from "@/components/mTitle";
	import {
		antiShake,
		printExcel
	} from "@/plugins/other.js";
	import {
		mapMutations,
		mapState
	} from "vuex";
	export default {
		name: "eplist",
		data() {
			return {
				fangyikaiguan:'',
				fangyikaiguanId:'',
				MyCheckboxList: [{
						name: "进行中",
						status: "10,11,20,30,40,42,43,44,45,46,49"
					},
					{
						name: "已完成",
						status: "60"
					},
					{
						name: "进场前取消",
						status: "61,62,64,65,66,69"
					},
					{
						name: "进场后取消",
						status: "63"
					}
				],
				statusarr: [],
				listitem: [{
					name: "统计分析"
				}, {
					name: "防疫列表"
				}],
				datamsg: [],
				arrlist: {
					list: []
				},
				count: "", //车次
				suttlesum: "", //合计净重
				conditions: {
					page: 1,
					limit: 20,
					peopleType: "0"
				},
				allnum: 0,
				printable: [],
			};
		},
		computed: {
			...mapState(["conditionsList"]),
		},
		components: {
			mTitle,
		},
		created() {
			this.getjobdetails();
			this.getfangyi();
		},
		methods: {
			...mapMutations(["createConditions", "addnavigationMsg"]),
			handleCheckAllChange(val) {
				if (val) {
					this.conditions.peopleType = null;
				} else {
					this.conditions.peopleType = "0";
				}
			},
			async getfangyi() {
				const {
					data
				} = await this.$http(
					"api1",
					"/sys/dic/list",
					"get",
					{"dictionaryType":"防疫开关"}
				);
				if (data.code != 0) return this.$message.error(data.msg);
				this.fangyikaiguan = data.data[0]["val"];
				this.fangyikaiguanId = data.data[0]["id"];
			},
			async guankaifangyi(){
				var _this=this;
			
				const { data } = await this.$http("api1", "/sys/dic/update", "post", {
				  id: _this.fangyikaiguanId,
				  val:_this.fangyikaiguan
				});
				if (data.code != 0) return this.$message.error(data.msg);
				this.$message.success("修改成功");
				
			},
			numConvertName(num) {
				var result = "";
				switch (num) {
					case 10:
						result = "待接单";
						break;
					case 11:
						result = "待车队确认";
						break;
					case 20:
						result = "待缴费";
						break;
					case 30:
						result = "待审核";
						break;
					case 40:
						result = "待进场";
						break;
					case 42:
						result = "进卡口";
						break;
					case 43:
						result = "回皮";
						break;
					case 44:
						result = "装车";
						break;
					case 45:
						result = "过重";
						break;
					case 46:
						result = "无作业";
						break;
					case 60:
						result = "完成";
						break;
					case 61:
						result = "拒绝接单";
						break;
					case 62:
						result = "进场前取消";
						break;
					case 63:
						result = "进场后取消";
						break;
					case 64:
						result = "审核未通过";
						break;
					case 65:
						result = "抢单车队拒绝";
						break;
					case 66:
						result = "审核前取消";
						break;
					case 49:
						result = "取消待审核";
						break;
					case 68:
						result = "取消未通过";
						break;
				}
				return result;
			},
			async getjobdetails(num) {
				if (this.datamsg) {
					this.conditions.startTime = this.datamsg[0] || "";
					this.conditions.endTime = this.datamsg[1] || "";
				} else {
					this.conditions.startTime = null;
					this.conditions.endTime = null;
				}
				num && (this.conditions.limit = num);
				if (this.statusarr.length == 0) {
					this.conditions.status = "";
				} else {
					this.conditions.status = this.statusarr.toString();
				}

				console.log(this.conditions)
				const {
					data
				} = await this.$http(
					"api1",
					"/driver/epidemicprevention/getEpidemicPrevention",
					"get",
					this.conditions
				);
				if (data.code != 0) return this.$message.error(data.msg);
				this.suttlesum = data.suttlesum;
				this.count = data.count;
				this.arrlist = data.data;
			},
			printList() {
				this.conditions.startTime = this.datamsg[0] || "";
				this.conditions.endTime = this.datamsg[1] || "";
				var filname = "进港区车辆防疫登记表(含随车人员)";
				if (this.conditions.peopleType == "0") {
					filname = "进港区车辆防疫登记表(不含随车人员)";
				}
				if (this.statusarr.length == 0) {
					this.conditions.status = "";
				} else {
					this.conditions.status = this.statusarr.toString();
				}
				printExcel.call(
					this,
					"/driver/epidemicprevention/exportlistdetails",
					filname,
					this.conditions,
					"get"
				);
			},
			iteminfofun(obj) {
				// this.addnavigationMsg([
				//   { name: "统计分析" },
				//   { name: "防疫列表", path: "/statistics/eplist" },
				//   { name: "详情" },
				// ]);
				this.$router.push("/statistics/epinfomsg/" + obj.id.split("-")[1]);
			},
			querylist() {
				antiShake((_) => {
					this.conditions.page = 1;
					this.getjobdetails();
				});
			},
			cleartiaojian() {
				antiShake((_) => {
					this.switchcheck = 0;
					this.datamsg = [];
					this.conditions.pno = null;
					this.conditions.driverName = null;
					this.conditions.startTime = null;
					this.conditions.endTime = null;
					this.conditions.tuJing = null;
					this.conditions.plate = null;
					this.conditions.pno = null;
					this.getjobdetails();
				});
			},
			handleCurrentChange(index) {
				if (this.arrlist.totalCount < this.conditions.limit) return;
				this.conditions.page = index;
				this.getjobdetails();
			},
			renderHeader() {
				console.log(arguments)
			}
		},
	};
</script>
<style lang="scss" src="@/assets/components.scss" scoped></style>
